module.exports = __webpack_public_path__ + "static/media/HandoSoftTrial-Bold.7e6ae649.ttf";